const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 200, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 150, flex: 1 },
  { field: "tempRefrigeranteEvaporado", headerName: "Temp Refrigerante Evaporado", minWidth: 250, flex: 1 },
  { field: "tempRefrigeranteCondensado", headerName: "Temp Refrigerante Condensado", minWidth: 250, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp Proceso Entrada", minWidth: 200, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp Proceso Salida", minWidth: 200, flex: 1 },
  { field: "tempAceiteCarter", headerName: "Temp Aceite Carter", minWidth: 200, flex: 1 },
  { field: "tempAceiteChumacera", headerName: "Temp Aceite Chumacera", minWidth: 200, flex: 1 },
  { field: "tempDescarga", headerName: "Temp Descarga", minWidth: 200, flex: 1 },
  { field: "tempMotor", headerName: "Temp del Motor", minWidth: 200, flex: 1 },
  { field: "tempAguaTorreEntrada", headerName: "Temp Agua Torre Entrada", minWidth: 250, flex: 1 },
  { field: "tempAguaTorreSalida", headerName: "Temp Agua Torre Salida", minWidth: 250, flex: 1 },
  { field: "tempAmbiente", headerName: "Temp Ambiente", minWidth: 200, flex: 1 },
  { field: "presAbsolutaSuccion", headerName: "Pres Absoluta de Succión", minWidth: 250, flex: 1 },
  { field: "presAbsolutaDescarga", headerName: "Pres Absoluta de Descarga", minWidth: 250, flex: 1 },
  { field: "presAbsolutaAceite", headerName: "Pres Absoluta de Aceite", minWidth: 250, flex: 1 },
  { field: "presAbsolutaAceiteFiltro", headerName: "Pres Absoluta de Aceite en Filtro", minWidth: 300, flex: 1 },
  { field: "presAbsolutaPurga", headerName: "Pres Absoluta Purga", minWidth: 250, flex: 1 },
  { field: "voltajeLinea", headerName: "Voltaje de Línea", minWidth: 200, flex: 1 },
  { field: "amperajeMotor", headerName: "Amperaje del Motor", minWidth: 200, flex: 1 },
  { field: "posicionSlideValve", headerName: "Posición Slide-Valve", minWidth: 250, flex: 1 },
  { field: "condicionActual", headerName: "Condición Actual", minWidth: 200, flex: 1 },
  { field: "intervencionControl", headerName: "Intervención Control", minWidth: 250, flex: 1 },
  { field: "cargaDescargaNada", headerName: "Carga/Descarga/Nada", minWidth: 250, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "interlockBombaAceite", headerName: "Interlock Bomba de Aceite", minWidth: 250, flex: 1 },
  { field: "interlockMotorCompresor", headerName: "Interlock Motor de Compresor", minWidth: 250, flex: 1 },
  { field: "fslAguaTorre", headerName: "FSL Agua Torre", minWidth: 200, flex: 1 },
  { field: "fslAguaHelada", headerName: "FSL Agua Helada", minWidth: 200, flex: 1 },
  { field: "fslMovimientoAxial", headerName: "FSL Movimiento Axial", minWidth: 250, flex: 1 },
  { field: "humedadPurga", headerName: "Humedad Purga", minWidth: 200, flex: 1 },
  { field: "arranqueBombaAceite", headerName: "Arranque Bomba Aceite", minWidth: 250, flex: 1 },
  { field: "compresor", headerName: "Compresor", minWidth: 200, flex: 1 },
  { field: "resistenciasCalefactoras", headerName: "Resistencias Calefactoras", minWidth: 250, flex: 1 },
  { field: "load", headerName: "Load", minWidth: 200, flex: 1 },
  { field: "unload", headerName: "Unload", minWidth: 200, flex: 1 },
  { field: "falla", headerName: "Falla", minWidth: 200, flex: 1 },
  { field: "alarma", headerName: "Alarma", minWidth: 200, flex: 1 },
  { field: "valvulaGasesCalientes", headerName: "Válvula de Gases Calientes", minWidth: 250, flex: 1 },
  { field: "activarPurga", headerName: "Activar Purga", minWidth: 200, flex: 1 },
  { field: "arranqueBombaAguaTorre", headerName: "Arranque Bomba Agua de Torre", minWidth: 300, flex: 1 },
  { field: "arranqueBombaAguaHelada", headerName: "Arranque Bomba Agua Helada", minWidth: 300, flex: 1 },
  { field: "arranqueVentiladorTorre", headerName: "Arranque Ventilador Torre", minWidth: 300, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 180, flex: 0.5 },
  { field: "numFalla1", headerName: "Num Falla 1", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 180, flex: 0.5 },
  { field: "numFalla2", headerName: "Num Falla 2", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 180, flex: 0.5 },
  { field: "numFalla3", headerName: "Num Falla 3", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 180, flex: 0.5 },
  { field: "numFalla4", headerName: "Num Falla 4", minWidth: 150, flex: 0.5 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 180, flex: 0.5 },
  { field: "numFalla5", headerName: "Num Falla 5", minWidth: 150, flex: 0.5 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 300, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 300, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempRefrigeranteEvaporado: row["Temp Refrigerante Evaporado"],
  tempRefrigeranteCondensado: row["Temp Refrigerante Condensado"],
  tempProcesoEntrada: row["Temp Proceso Entrada"],
  tempProcesoSalida: row["Temp Proceso Salida"],
  tempAceiteCarter: row["Temp Aceite Carter"],
  tempAceiteChumacera: row["Temp Aceite Chumacera"],
  tempDescarga: row["Temp Descarga"],
  tempMotor: row["Temp del Motor"],
  tempAguaTorreEntrada: row["Temp Agua Torre Entrada"],
  tempAguaTorreSalida: row["Temp Agua Torre Salida"],
  tempAmbiente: row["Temp Ambiente"],
  presAbsolutaSuccion: row["Pres Absoluta de Succion"],
  presAbsolutaDescarga: row["Pres Absoluta de Descarga"],
  presAbsolutaAceite: row["Pres Absoluta de Aceite"],
  presAbsolutaAceiteFiltro: row["Pres Absoluta de Aceite en Filtro"],
  presAbsolutaPurga: row["Pres Absoluta Purga"],
  voltajeLinea: row["Voltaje de Linea"],
  amperajeMotor: row["Amperaje del motor"],
  posicionSlideValve: row["Posicion slide-valve"],
  condicionActual: row["Condicion Actual"],
  intervencionControl: row["Intervencion Control"],
  cargaDescargaNada: row["Carga_Descarga_Nada"],
  controlCarga: row["Control de Carga"],
  interlockBombaAceite: row["Interlock Bomba de Aceite"],
  interlockMotorCompresor: row["Interlock Motor de Compresor"],
  fslAguaTorre: row["FSL Agua Torre"],
  fslAguaHelada: row["FSL Agua Helada"],
  fslMovimientoAxial: row["FSL Movimiento Axial"],
  humedadPurga: row["Humedad Purga"],
  arranqueBombaAceite: row["Arranque bomba aceite"],
  compresor: row["Compresor"],
  resistenciasCalefactoras: row["Resistencias Calefactoras"],
  load: row["Load"],
  unload: row["Unload"],
  falla: row["Falla"],
  alarma: row["Alarma"],
  valvulaGasesCalientes: row["Valvula de Gases Calientes"],
  activarPurga: row["Activar Purga"],
  arranqueBombaAguaTorre: row["Arranque de Bomba agua de Torre"],
  arranqueBombaAguaHelada: row["Arranque de Bomba Agua Helada"],
  arranqueVentiladorTorre: row["Arranque ventilador de Torre"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numFalla1: row["Num Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numFalla2: row["Num Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numFalla3: row["Num Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numFalla4: row["Num Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numFalla5: row["Num Falla 5"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

export const centrifugaConsultaConfig = {
  title: "CENTRIFUGA",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/centrifuga/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Centrifuga",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};